export const MATTER_EXPENSE_CATEGORY_OPTIONS = [
  "Copy Services",
  "Court Reporter",
  "Courts",
  "Expert Witness",
  "General",
  "Health Insurances",
  "Health Providers",
  "Interpreter",
  "Investigation",
  "Law Firms",
  "Litigation Firms",
  "Loan Companies",
  "Mediators",
  "Medical Lien Holders",
  "Misc Lien Holders",
  "Police Departments",
  "Process Services",
  "Record Retrieval Service",
  "Settlement Advance",
  "Subrogation Companies",
  "Other",
] as const;

export const MATTER_EXPENSE_PAID_BY_METHOD_OPTIONS = [
  "Cash",
  "Check",
  "Credit Card",
] as const;

export const MATTER_EXPENSE_PAID_STATUS_OPTIONS = [
  "Unpaid",
  "Partially Paid",
  "Paid",
] as const;
